<div class="container">

  <app-header-dialog [iconName]="'dashboard_customize'">
    Anuidade
  </app-header-dialog>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_annuityService.spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div class='bread-crumb' flex>
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _annuityService.breadCrumb(_annuityService.localTitle) }}
  </div>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>card_giftcard</mat-icon>
        <div>Anuidade</div>
      </ng-template>


      <div class='tab-content-name'>

        <div>

          <mat-form-field class="name-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="productForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="productForm.controls.name.hasError('required')">
              O Nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="annuity_from-width" appearance="outline">
            <mat-label>Vigência</mat-label>
            <input matInput type="number" [errorStateMatcher]="matcher"
              [formControl]="productForm.controls.annuity_from" autocomplete="off">
            <mat-error *ngIf="productForm.controls.annuity_from.hasError('required')">
              Campo obrigatório
            </mat-error>
          </mat-form-field>

        </div>

        <mat-form-field class="name-width" appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="productForm.controls.name_en"
            autocomplete="off">
          <mat-error *ngIf="productForm.controls.name_en.hasError('required')">
            Name is madatory
          </mat-error>
        </mat-form-field>

        <span class="active-width">
          <mat-checkbox [formControl]="productForm.controls.active">
            Disponível
          </mat-checkbox>
        </span>

        <!--disablePix-->
        <span class="active-width">
          <mat-checkbox [formControl]="productForm.controls.disablePix">
            Desabilitar Pix
          </mat-checkbox>
        </span>

      </div>

      <div class='tab-content-text'>

        <div style='margin-right: 10px; width:50%;'>
          <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="productForm.controls.text" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="productForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>
        </div>

        <div style='margin-left: 10px; width:50%;'>
          <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="productForm.controls.text_en" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="productForm.controls.text_en.hasError('required')">
            Text is mandatory
          </mat-error>
        </div>
      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

        <button mat-raised-button (click)='insert()' [disabled]="productForm.invalid" *ngIf="!_annuityService.isEdit">
          i<mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

        <button mat-raised-button (click)='update()' [disabled]="productForm.invalid" *ngIf="_annuityService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

      </div>

    </mat-tab>


    <mat-tab *ngIf='_annuityService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>image_search</mat-icon>
        <div>Imagem</div>
      </ng-template>

      <div class='tab-content-img'>

        <mat-card>

          <h4>Imagem Principal (pt)</h4>

          <div class='img-input'>
            <input #file type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_annuityService.previewImage($event)" />
          </div>
          <div class="post-image">
            <img [src]="_annuityService.storedImage" *ngIf="_annuityService.storedImage">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

        <mat-card>
          <h4>Imagem Principal (en)</h4>

          <div class='img-input'>
            <input #file_en type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_annuityService.previewImage_en($event)" />
          </div>
          <div class="post-image">
            <img [src]="_annuityService.storedImage_en" *ngIf="_annuityService.storedImage_en">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file_en.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

        <mat-card>

          <h4>Imagem Botão (pt)</h4>

          <div class='img-input'>
            <input #file_button type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_annuityService.previewImageButton($event)" />
          </div>
          <div class="post-image">
            <img [src]="_annuityService.storedButton" *ngIf="_annuityService.storedButton">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file_button.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

        <mat-card>

          <h4>Imagem Botão (en)</h4>

          <div class='img-input'>
            <input #file_button_en type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_annuityService.previewImageButton_en($event)" />
          </div>
          <div class="post-image">
            <img [src]="_annuityService.storedButton_en" *ngIf="_annuityService.storedButton_en">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file_button_en.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>


      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='update()' [disabled]="productForm.invalid" *ngIf="_annuityService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_annuityService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>attach_money</mat-icon>
        <div>Valores</div>
      </ng-template>

      <div class='tab-content-lot'>

        <!-- TABLE  matSortActive="name" matSortDirection='asc' matSortDisableClear='true' -->
        <mat-table [dataSource]="_annuityLotService.productLotsDataSource" matSort>

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>layers</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Lote </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }} </mat-cell>
          </ng-container>

          <!-- Date Until Column -->
          <ng-container matColumnDef="until_date">
            <mat-header-cell *matHeaderCellDef> Até </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.until_date.seconds*1000 | date: 'dd-MM-yyyy' }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openLotDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteLot(element)' style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedLotColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedLotColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->
      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='openLotDialog(null)'>
          <mat-icon class='icon-add'>add_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_annuityService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>people</mat-icon>
        <div>Apoio</div>
      </ng-template>

      <div class='tab-content-banner'>

        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <button mat-raised-button (click)='openBannerDialog()'>
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="sponsorsDataSource" style='height:380px; overflow:auto; margin: 0 0 10px 0;'>

          <!-- image -->
          <ng-container matColumnDef="image">
            <mat-header-cell *matHeaderCellDef>Imagem</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container>
                <img class='banner_image' [src]='element.image'>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- Link Column -->
          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.link }}
            </mat-cell>
          </ng-container>

          <!-- type Column -->
          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef> Tela </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.type }}
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='removeBannerSponsor(element)' style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSponsorColumns">
          </mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedSponsorColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->
      </div>


    </mat-tab>

  </mat-tab-group>

</div>